import { createContext } from 'react';

type TModalState = {
  open: boolean;
  title: string;
  message: string;
  primaryAction: (() => {}) | undefined;
  primaryActionLabel: string;
  isPrimaryDestructive: boolean;
};

export interface IModalContext {
  modalState: TModalState;
  setModalState: Function;
  dispatchModal: Function;
  };


export const ModalContext = createContext<IModalContext>({
  modalState: {
    open: false,
    title: "",
    message: "",
    primaryAction: undefined,
    primaryActionLabel: "",
    isPrimaryDestructive: false,
  },
  setModalState: () => {},
  dispatchModal: () => {},
});
